import { createFileRoute } from '@tanstack/react-router';
import { DeviceManagementPage } from '@/features/devices';

interface DevicesSearchParams {
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export const Route = createFileRoute('/_app/devices/')({
  component: DeviceManagementPage,
  validateSearch: (search: Record<string, unknown>): DevicesSearchParams => {
    return {
      page: search.page ? Number(search.page) : undefined,
      pageSize: search.pageSize ? Number(search.pageSize) : undefined,
      search: search.search as string | undefined,
      sortBy: search.sortBy as string | undefined,
      sortOrder: search.sortOrder as 'asc' | 'desc' | undefined,
    };
  },
});
